import { useMutation } from 'react-query';

import { editComment } from 'services/messages';

export default function useEditComment() {
  const mutation = useMutation({
    mutationFn: editComment,
  });

  return mutation;
}
